mutation SyncMyProfilePicture($force: Boolean) {
  sync: StreamToolsSyncMyProfilePicture(force: $force) {
    pictureUrl
    action
  }
}
